import $ from 'static/script/libs/jquery';
import defineComponent from 'flight';
import formatNumber from 'static/script/utils/format-number';

function BidNotifier() {

    this.defaultAttrs({
        leadingBidSum: '[data-leading-bid-sum]',
        nextBid: '[data-next-bid]',
        itemState: '[data-view-item-state]',
        binSection: '[data-view-item-bin-on-auction]',
        bidAmountField: '[data-bid-amount-field]',
        bidAmountLabel: '[data-bid-amount-label]',
        bidpreFilledAmountField: '[data-prefilled-input]',
        biddingHeadline: '[data-view-item-headline]',
        numberOfBids: '[data-bid-count]',
        leadingBidNotification: '[data-leading-bid-notification]',
        placeBidFormTemplate: '[data-place-bid-form]',
        bidForm: '.view-item-type-wrapper form',
        bidButton: '[data-bid-submit-button]',
        bidReservePrice: '.view-item-reserve-price',
        placeBidLinkTemplate: '[data-place-bid-link]',
        placeBidLink: '.view-item-action-enter-bid',
        reservePrice: '[data-view-item-reserve-price]',
        reservePriceTemplate: '[data-reserve-price-template]',
        memberId: null
    });

    this._handleClientEvent = function (evt, data) {
        if (!data.BidAmount) {
            return;
        }

        this.select('leadingBidSum').text(formatNumber.asMoney(data.BidAmount));
        this.select('nextBid').text(formatNumber.asMoney(data.NextValidBidAmount) + ' kr');
        this.select('numberOfBids').text(data.NumberOfBids);

        this.animateLeadingBidNotification('<span class="table-cell-middle"><h3>Nytt bud!</h3> <em>' + data.MemberAlias + '</em> leder med <strong>' + formatNumber.asMoney(data.BidAmount) + ' kr</strong></span>');
        this._updateReservePrice(data);

        if (data.MemberId !== this.attr.memberId) {
            this._updateActionHeader(data);
            this._updateActionForm(data);
        }
    };

    this._updateActionHeader = function (data) {
        if (this._hasLedSincePageLoad) {
            this.select('biddingHeadline')
                .html('<h2 class="view-item-actions-headline">Du har blivit överbjuden</h2>')
                .append('<p class="view-item-actions-text">' + data.MemberAlias + ' leder med ett bud på ' + formatNumber.asMoney(data.BidAmount) + ' kr.' + '</p>');
            this.select('itemState').removeClass('view-item-state-leading');
            this.select('itemState').addClass('view-item-state-overbid');
        }

    };

    this._updateActionForm = function (data) {
        this.select('bidAmountLabel').text('Lägg ' + formatNumber.asMoney(data.NextValidBidAmount) + ' kr eller mer:');
        this.select('bidForm').attr('action', '/Items/Bidding/ConfirmBid');
        this.select('bidButton').text('Lägg bud');

        if (this.select('placeBidLink').length === 0) {
            let linkTemplate = this.select('placeBidLinkTemplate').html();
            this.select('bidForm').before(linkTemplate);
        }
    };

    this._updateReservePrice = function (data) {
        if (data.ReservePriceReached) {
            this.select('binSection').remove();
            this.select('reservePrice').empty();
        } else {
            this.select('reservePrice').html(this.select('reservePriceTemplate').html());
        }
    };

    this.animateLeadingBidNotification = function (text) {
        let notification = this.select('leadingBidNotification');
        if (notification.length === 0) {
            return;
        }
        let container = notification.parent();
        let containerOffset = container.offset().top;

        if (notification.length > 1) {
            notification = notification.first();
        }

        let toggleFixed = _.debounce(function () {
            let scroll = $(document).scrollTop();
            if (scroll > containerOffset) {
                notification.addClass('fixed');
            } else {
                notification.removeClass('fixed');
            }
        }.bind(this), 100);


        notification.html(text);
        toggleFixed();
        notification.addClass('visible');
        $(window).off('scroll', toggleFixed).on('scroll', toggleFixed);

        if (this.animationTimer) {
            clearTimeout(this.animationTimer);
        }

        this.animationTimer = setTimeout(function () {
            $(window).off('scroll', toggleFixed);
            this.select('leadingBidNotification').removeClass('visible');
            this.animationTimer = null;
        }.bind(this), 4000);
    };

    this._onBidEntered = function () {
        this._bidEntered = true;
    };

    this.after('initialize', function () {
        this.on('keyup click touchstart', {
            bidAmountField: this._onBidEntered,
            bidpreFilledAmountField: this._onBidEntered
        });
        this.on(document, 'data:notifications:on-bid-update', this._handleClientEvent);
        this._hasLedSincePageLoad = this.select('itemState').hasClass('view-item-state-leading');
    });
}

module.exports = defineComponent.component(BidNotifier);


// WEBPACK FOOTER //
// ./src/EbaySweden.TouchWeb/static/script/app/ui/view-item/bid-notifier.js